import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

interface ConfirmationModalProps {
  show: boolean;
  title: string;
  description: string;
  onCancel: () => void;
  onConfirm: () => void;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  show,
  title,
  description,
  onCancel,
  onConfirm,
}) => {
  const { t } = useTranslation();
  return (
    <div className="modal-container">
      {show && (
        <Modal show={show} onHide={onCancel}>
          <Modal.Header closeButton>
            <Modal.Title>{title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {description}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={onCancel}>
              {t('tools.common.cancel')}
            </Button>
            <Button className="confirm-btn" onClick={onConfirm}>
              {t('tools.common.confirm')}
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </div>
  );
};

export default ConfirmationModal;